import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions, IPageChangeEvent } from '@covalent/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Receiving } from '../receiving';
import { ReceivingService } from '../receiving.service';
import { ReceivingItem } from '../receiving-item';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-receiving-items',
  templateUrl: './receiving-items.component.html',
  styleUrls: ['./receiving-items.component.scss']
})
export class ReceivingItemsComponent implements OnInit {
  receivingItems: ReceivingItem;
  subscription: Subscription = new Subscription();
  data: ReceivingItem[];
  totalOrderedMetersValue: number;
  totalReceivedMetersValue: number;
  totalWeightValue: number;

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'qtyOrdered', label: 'QTY Ordered (M)' },
    { name: 'qtyReceived', label: 'QTY Received (M)' },
    { name: 'weight', label: 'Weight (kg)' }
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dataTableService: TdDataTableService,
              private _dialogService: TdDialogService,
              private _receivingService: ReceivingService,
              private _viewContainerRef: ViewContainerRef,
              public _authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    /*this.subscription = this._receivingService
    .getReceivingItems()
    .subscribe((receivingItems: ReceivingItem[]) => {
      this.data = receivingItems;
      this.filteredData = this.data;
      this.filteredTotal = this.data.length;
      this.selectedRows = this.filteredData;
      this.filter();
      //this.totalOrderedMetersValue = this.data.reduce((acc, el) => acc + +el.qtyOrdered, 0);
      //this.totalReceivedMetersValue = this.data.reduce((acc, el) => acc + +el.qtyReceived, 0);
      this.totalWeightValue = this.data.reduce((acc, el) => acc + +el.weight, 0);
    });*/
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this.pageSize = pagingEvent.pageSize;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
    .filter((column: ITdDataTableColumn) => {
      return ((column.filter === undefined && column.hidden === true) ||
              (column.filter !== undefined && column.filter === false));
    }).map((column: ITdDataTableColumn) => {
      return column.name;
    });
    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this.pageSize);
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/receiving/receiving-items/receiving-items.component.ts